import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import padStart from 'lodash/padStart';
import startCase from 'lodash/startCase';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';

import PaymentIcon from 'Components/Payment/PaymentIcon';

import 'Components/Account/PaymentInformation/SavedPaymentMethod.scss';

export default function SavedCard({ method, forgetMethod, accountOverview }) {
  const {
    expiryMonth,
    expiryYear,
    lastFour,
    type,
    shopperEmail,
    primary,
  } = method;

  let { brand, name } = method;

  const isApplePay = brand && brand.includes('_applepay');

  if (isApplePay) {
    brand = brand.replace('_applepay', '');
    name = name.replace('_applepay', '');
  }

  const isExpired = expiryMonth && expiryYear && new Date(`20${expiryYear}-${padStart(Number(expiryMonth) + 2, 2, '0')}-01`) <= new Date();

  const expiresSoon = expiryMonth && expiryYear && new Date(`20${expiryYear}-${padStart(Number(expiryMonth) + 1, 2, '0')}-01`) <= new Date();

  const obfuscatedNumber = isApplePay ? `****${lastFour}` : `************${lastFour}`;

  let caseFixedName = name;

  if (name.charAt(0) !== name.charAt(0).toUpperCase()) {
    caseFixedName = startCase(name);
  }

  return (
    <React.Fragment>
      {!!primary && !!false &&
        <div className="account-table-row-title">
          <FormattedMessage id="account-saved-method.primary" defaultMessage="Default Payment Method" />
        </div>
      }
      <div className="account-saved-method">
        <div className="left-section">
          <div className="icon-details-container">
            <PaymentIcon name={name} type={brand || type} isApplePay={isApplePay} />
            <div className="method-details">
              <div className="method-detail">{isApplePay && 'ApplePay '}{caseFixedName} {shopperEmail || obfuscatedNumber}</div>
              {!!expiryMonth && !!expiryYear &&
                <div className={classNames('expiry-date', { isExpired: isExpired || expiresSoon })}>
                  {!isExpired && !expiresSoon &&
                    <FormattedMessage id="account-saved-method.expires" defaultMessage="Expires {expiryDate}" values={{ expiryDate: `${expiryMonth}/${expiryYear}` }} />
                  }
                  {expiresSoon && !isExpired &&
                    <FormattedMessage id="account-saved-method.expires-soon" defaultMessage="Expiring Soon - {expiryDate}" values={{ expiryDate: `${expiryMonth}/${expiryYear}` }} />
                  }
                  {isExpired &&
                    <FormattedMessage id="account-saved-method.expired" defaultMessage="Expired {expiryDate}" values={{ expiryDate: `${expiryMonth}/${expiryYear}` }} />
                  }
                </div>
              }
            </div>
          </div>
          {!!expiryMonth && !!expiryYear && !accountOverview &&
            <div className={classNames('expiry-date', { isExpired: isExpired || expiresSoon })}>
              {expiresSoon && !isExpired &&
                <div className="expired-warning">
                  <FormattedMessage id="account-saved-method.expires-warning" defaultMessage="This card will expire within 30 days. Please update or delete it." />
                </div>
              }
              {isExpired &&
                <div className="expired-warning">
                  <FormattedMessage id="account-saved-method.expired-warning" defaultMessage="This card has expired. Please update or delete it." />
                </div>
              }
            </div>
          }
        </div>
        <div className="right-section">
          {!accountOverview &&
            <button type="button" className="btn btn-link delete-method" onClick={() => forgetMethod(method)}>
              <FormattedMessage id="account-saved-method.delete" defaultMessage="Delete" />
              <FontAwesomeIcon icon={faCircleXmark} />
            </button>
          }
        </div>
      </div>
    </React.Fragment>
  );
}

SavedCard.propTypes = {
  method: PropTypes.shape({}).isRequired,
  forgetMethod: PropTypes.func.isRequired,
  accountOverview: PropTypes.bool.isRequired,
};

SavedCard.defaultProps = {
  accountOverview: false,
};
